import * as d3 from "d3";
import { Chart } from "@/utils/Chart";
import i18n from "../lang/lang";

export function ChartBarSimpleVertical(alias, chartData, fontSize = 1) {
  this.alias = alias;
  this.chartData = chartData;
  this.data = chartData.data;
  var chart = new Chart(alias, null, {
    top: 10,
    right: 10,
    bottom: 50,
    left: 10,
  });
  this.render = function () {
    // set the ranges
    var maxValue = d3.max(this.data, function (d) {
      return d.value;
    });

    var x = d3
      .scaleBand()
      .range([0, chart.chartWidth])
      .padding(0.3)
      .domain(
        this.data.map(function (d) {
          return i18n.tc(d.label);
        })
      );
    var y = d3
      .scaleLinear()
      .range([chart.chartHeight, 0])
      .domain([0, maxValue * 1.1]);

    // append the rectangles for the bar chart
    var bar = chart.svg.selectAll(".bar").data(this.data);
    var rect = bar
      .enter()
      .append("rect")
      .style("fill", (d) => {
        return d.color || chart.getColor(d.label);
      })
      .attr("x", function (d) {
        return x(i18n.tc(d.label));
      })
      .attr("width", x.bandwidth())
      .attr("y", chart.chartHeight)
      .attr("height", 0)
      .on("mouseover", function (d) {
        chart.openTooltip(i18n.tc(d.label) + ": " + chart.format(d, d.type), fontSize);
      })
      .on("mouseout", function () {
        chart.closeTooltip();
      })
      .on("mousemove", function () {
        chart.moveTooltip(d3.event.pageX, d3.event.pageY);
      });
    /* .on('mouseover', () => { this.tooltip.style('display', null) })
    .on('mouseout', () => { this.tooltip.style('display', 'none') })
    .on('mousemove', (d) => {
      var xPosition = d3.mouse(this)[0] - 5
      var yPosition = d3.mouse(this)[1] - 5
      this.tooltip.attr('transform', 'translate(' + xPosition + ',' + yPosition + ')')
      this.tooltip.select('text').text(d[1] - d[0])
    }) */

    rect
      .transition(chart.transition)
      .attr("height", function (d) {
        return chart.chartHeight - y(d.value);
      })
      .attr("y", function (d) {
        return y(d.value);
      });

    var text = chart.svg
      .selectAll("text")
      .data(this.data)
      .enter()
      .append("text")
      .attr("x", function (d) {
        return x(i18n.tc(d.label));
      })
      .attr("y", chart.chartHeight)
      .attr("dy", "-0.3rem")
      .attr("dx", x.bandwidth() / 2)
      .style("text-anchor", "middle")
      .style("font-size", "0.625rem")
      .style("font-family", "Montserrat-Regular")
      .text(function (d) {
        return chart.format(d, d.type);
      });

    text.transition(chart.transition).attr("y", function (d) {
      return y(d.value);
    });

    chart.drawAxis(
      x,
      y,
      this.chartData.xAxis,
      this.chartData.yAxis,
      null,
      true
    );
    chart.svg
      .selectAll(".tick text")
      .attr("x", 0)
      .attr("y", 15)
      .call(chart.wrap, x.bandwidth());
  };
}
